export default __webpack_public_path__ + "static/media/time.81dea9e1.png";